import { combineReducers } from 'redux';

import execute, * as fromExecute from './execute';
import del, * as fromDel from './del';
import update, * as fromUpdate from './update';
import select, * as fromSelect from './select';
import fetch, * as fromFetch from './fetch';
import manual, * as fromManual from './manual';
import list, * as fromList from './list';

export default combineReducers({
  fetch,
  select,
  update,
  del,
  execute,
  manual,
  list,
});

export const areFetching = (state) => fromFetch.areFetching(state.fetch);

export const getFunnels = (state) => fromFetch.getFunnels(state.fetch);

export const getSelected = (state) => fromSelect.getSelected(state.select);

export const getFunnelSQL = (state) => fromSelect.getFunnelSQL(state.select);

export const getError = (state) => fromSelect.getError(state.select);

export const isUpdating = (state) => fromUpdate.isUpdating(state.update);

export const getUpdating = (state) => fromUpdate.getUpdating(state.update);

export const getUpdatingId = (state) => fromUpdate.getUpdatingId(state.update);

export const isDeleting = (state) => fromDel.isDeleting(state.del);

export const getExecutionResult = (state) => fromExecute.getExecutionResult(state.execute);

export const getExecutionTime = (state) => fromExecute.getExecutionTime(state.execute);

export const getConversionInterval = (state) => fromExecute.getConversionInterval(state.execute);

export const getExecuteSentQuery = (state) => fromExecute.getSentQuery(state.execute);

export const getView = (state) => fromExecute.getView(state.execute);

export const isExecuting = (state) => fromExecute.isExecuting(state.execute);

export const getExecuteId = (state) => fromExecute.getExecuteId(state.execute);

export const isManualEnabled = (state) => fromManual.isEnabled(state.manual);

export const getManualCode = (state) => fromManual.getCode(state.manual);

export const getFilterValue = (state) => fromList.getFilterValue(state.list);

export const getSideListContainerWidth = (state) => fromList.getSideListContainerWidth(state.list);

export const isFunnelExists = (state, funnel) =>
  !!getFunnels(state).find(({ id }) => id === funnel.id);
